import toast from "react-hot-toast";
import axios from 'axios';
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth';
import ls from "local-storage";
import moment from 'moment';

import CommonHelper from "../helpers/CommonHelper";
import { API_ENDPOINT } from "./constants";
import TrackingAPI from './TrackingAPI';

const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;
const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;
const FIREBASE_WEB_API_KEY = import.meta.env.VITE_FIREBASE_WEB_API_KEY;

const firebaseConfig = {
  apiKey: FIREBASE_WEB_API_KEY,
  authDomain: `${FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: FIREBASE_PROJECT_ID,
  appId: FIREBASE_APP_ID
};

const firebaseApp = initializeApp(firebaseConfig);

const firebaseAuth = getAuth(firebaseApp);

const googleProvider = new GoogleAuthProvider();

const UsersAPI = {

  getFirebaseApp() {
    return firebaseApp;
  },

  async signInWithGoogle() {
    try {
      const result = await signInWithPopup(firebaseAuth, googleProvider);
      const idToken = await result.user.getIdToken();
      const rewardfulId = window?.Rewardful?.referral;

      const response = (await axios.post(`${API_ENDPOINT}/firebase/google/oauth`, {
        idToken,
        rewardfulId
      })).data;

      if (response.token != undefined) {
        const visitor_id = ls.get('visitor_id');
        if (visitor_id) {
          await fetch(`https://sconvtrk.com/conversion/f6bfb4a3ef2b36dc17473a85e583fd36ec2a9dff/?visitor_id=${visitor_id}&aid=288863`);
        }

        const click_id = ls.get('click_id');
        if (click_id) {
          await fetch(`https://1tjqs.bemobtrcks.com/postback?cid=${click_id}&goal=1&status=registration`);
        }
        const token = response.token;
        window.localStorage.setItem('token', token);
        window.location.reload();
        // Proceed with your application's logic, e.g., store user info in local storage
      } else {
        toast.error('Authentication failed');
      }
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response?.data?.message;
        toast.error(errorMessage);
      } else {
        toast.error('Error during Google sign-in');
      }
    }
  },

  async signInWithApple() {
    try {
      const provider = new OAuthProvider('apple.com');
      const result = await signInWithPopup(firebaseAuth, provider);
      const idToken = await result.user.getIdToken();

      const response = (await axios.post(`${API_ENDPOINT}/firebase/google/oauth`, {
        idToken
      })).data;

      if (response.token != undefined) {
        const token = response.token;
        window.localStorage.setItem('token', token);
        window.location.reload();
        // Proceed with your application's logic, e.g., store user info in local storage
      } else {
        console.error('Authentication failed:', response.message);
        // Handle the error
        // use toast
        toast.error('Authentication failed');
      }
    } catch (error) {
      console.error('Error during Apple sign-in:', error);
      toast.error('Error during Apple sign-in');
    }
  },

  async deleteUser() {
    try {
      await axios.post(`${API_ENDPOINT}/users/delete`);
    } catch (exc) {

    }
  },

  async login(email, password) {
    try {
      const pld = (await axios.post(`${API_ENDPOINT}/users/login`, {
        email: email,
        password: password
      })).data;
      const token = pld.token;
      if (token != undefined) {
        window.localStorage.setItem('token', token);
        const u = await this.getMe();
        return u;
      }
    } catch (exc) {

    }
  },

  async signup(email, password, marketingData = {}) {
    try {
      const intent = marketingData?.intent;
      const dialogId = marketingData?.dialogId;
      const scenarioId = marketingData?.scenarioId;
      const gameId = marketingData?.gameId;
      const lsCharacterName = ls('characterName');
      const lsCharacterDescription = ls('ero_user_description');
      const lsGender = ls('ero_gender');

      let rewardfulId;
      try {
        rewardfulId = window.Rewardful.referral;
      } catch (exc) {
        TrackingAPI.trackEvent('error_rewardful_signup', { message: exc });
      }

      ls('tried_to_register', true);
      const pld = (await axios.post(`${API_ENDPOINT}/users/signup`, {
        email: email,
        password: password,
        signupUrl: window.location.href,
        characterName: lsCharacterName,
        characterGender: lsGender,
        characterDescription: lsCharacterDescription,
        rewardfulId: rewardfulId
      }, {
        params: {
          intent: intent,
          dialogId: dialogId,
          scenarioId: scenarioId,
          gameId: gameId,
        }
      })).data;

      const token = pld.token;

      if (token == undefined) {
        throw new Error('Token is undefined');
      }

      window.localStorage.setItem('token', token);
      const u = await this.getMe();

      if (!pld.isLogin) {
        TrackingAPI.trackEvent('rewardful_signup', { message: `window.Rewardful: ${window.Rewardful} window.Rewardful.referral: ${rewardfulId}` });
        CommonHelper.yandexTrackEvent('sign-up');
        window.gtag('event', 'conversion', {
          'send_to': 'AW-16691672461/1rPZCJiml90ZEI3rmpc-',
          'value': 1.0,
          'currency': 'EUR'
        });
      }

      return { user: u, registrationCompletedWithLogin: pld.isLogin };
    } catch (exc) {
      if (exc.response) {
        const errorMessage = exc.response.data.message;
        toast.remove();
        toast.error(errorMessage);
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  },

  async getMe() {
    const token = window.localStorage.getItem('token');
    if (token == undefined) {
      return undefined;
    }
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/me`)).data;
      return pld;
    } catch (exc) {

    }
  },


  async getAllUsers() {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/all-users`)).data;
      return pld;
    } catch (exc) {

    }
    return [];
  },

  async getUser(userId) {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/support/users/${userId}`)).data;
      return pld;
    } catch (exc) {

    }
  },

  async getUserActivityItems(userId) {
    try {
      const pld = (await axios.get(`${API_ENDPOINT}/support/users/${userId}/activity-metrics`, {
        params: {
          from: +moment().add(-6, 'months'),
          to: +moment(),
          limit: 100000
        }
      })).data;
      return pld;
    } catch (exc) {

    }
  },

  async updateUser(data) {
    const pld = (await axios.put(`${API_ENDPOINT}/users`, {
      ...data
    })).data;
    return pld;
  },

  async getUserFinanceInfo(userId) {
    const pld = (await axios.get(`${API_ENDPOINT}/support/users/${userId}/transactions`)).data;
    return pld;
  },

  async getUserCouponsUsages(userId) {
    const pld = (await axios.get(`${API_ENDPOINT}/support/users/${userId}/coupons`)).data;
    return pld;
  },

  async searchUser(text) {
    const pld = (await axios.get(`${API_ENDPOINT}/support/search`, {
      params: {
        q: text
      }
    })).data;
    return pld;
  }


};

export default UsersAPI;